@if (loading) {
    <div class="d-flex justify-content-center align-items-center">
        <span class="loader" role="status"></span>
    </div>
}
